module.exports = __webpack_public_path__ + "prod/1.42.2/img/system-four-h5.5f7c0981.png";